import { Component, OnInit } from "@angular/core";
import { ModalConfirmationService } from "../../../insurgo-services/modalTemplates/confirmation-modal/confirmation-modal.service";
import { UserService } from "../../../insurgo-services/user.service";
import { ButtonRendererComponent } from "../../../insurgo-services/cellRenderers/button.renderer.component";
import { AddUserService } from "../../../insurgo-services/modalTemplates/addUser/addUser.service";
import { dateFormatter } from "../../../insurgo-services/valueFormatters/timestampFormatter";
import { UserRoleLabels } from "../../../insurgo-services/constants/user-roles.constant";
import { ToastService } from "../../../insurgo-services/toast.service";

@Component({
  selector: "ngx-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
  public columnDefs;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public gridOptions;

  constructor(
    private _modalConfirmationService: ModalConfirmationService,
    private toastService: ToastService,
    private _userService: UserService,
    private _addUserService: AddUserService
  ) {
    this.gridOptions = {
      onRowDoubleClicked: this.rowDoubleClick.bind(this),
    };
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    };
    this.columnDefs = [
      {
        headerName: "ID",
        field: "id",
        flex: 1,
        minWidth: 120,
        tooltipField: "id",
      },
      {
        headerName: "Name",
        field: "name",
        flex: 2,
        minWidth: 120,
        tooltipField: "name",
        sortable: true,
        sort: "asc",
      },
      {
        headerName: "Email",
        field: "email",
        flex: 3,
        minWidth: 120,
        tooltipField: "email",
      },
      {
        headerName: "Type",
        field: "userRole",
        flex: 2,
        minWidth: 120,
        valueFormatter: this.userTypeFormatter,
      },
      {
        headerName: "Verified",
        field: "emailVerified",
        minWidth: 120,
        flex: 2,
        valueFormatter: this.verifiedFormatter,
      },
      {
        headerName: "Lock Status",
        field: "accountLocked",
        minWidth: 120,
        flex: 2,
        valueFormatter: this.lockFormatter,
      },
      {
        headerName: "Joined Date",
        field: "joinedDate",
        minWidth: 120,
        flex: 2,
        valueFormatter: dateFormatter,
      },
      {
        headerName: "Actions",
        minWidth: 200,
        filter: false,
        sortable: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          onClick: this.showAccountModal.bind(this),
          buttons: [
            { id: "view", label: "", class: "primary", icon: "eye-outline" },
            {
              id: "lock",
              label: "",
              class: "danger",
              icon: "lock-outline",
              tooltip: "lock account",
              show: this.buttonLockDecider,
            },
            {
              id: "unlock",
              label: "",
              class: "success",
              icon: "unlock-outline",
              tooltip: "unlock account",
              show: this.buttonUnLockDecider,
            },
            {
              id: "re-invite",
              label: "",
              class: "success",
              icon: "email-outline",
              tooltip: "Send a new invite",
              show: this.reInviteDecider,
            },
          ],
        },
      },
    ];
    this.context = { componentParent: this };
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      filter: true,
      resizable: true,
    };
  }

  userData: Object[];

  reInviteDecider(data) {
    if (data.emailVerified === 0) return true;
    return false;
  }
  buttonUnLockDecider(data) {
    if (data.accountLocked === 1) return true;
    return false;
  }
  buttonLockDecider(data) {
    if (data.accountLocked === 0) return true;
    return false;
  }

  verifiedFormatter(params) {
    return params.value === 1 ? "Verified" : "Unverified";
  }

  userTypeFormatter(params) {
    return UserRoleLabels[params.value] || "Unknown";
  }

  lockFormatter(params) {
    let returnValue = "locked";
    if (params.value === "0" || params.value === 0) {
      returnValue = "open";
    }

    return returnValue;
  }

  ngOnInit() {
    this.reloadUsers();
  }

  reloadUsers() {
    this._userService.getAllUsers().subscribe(
      (users) => {
        this.userData = users.map((i) => {
          i.name = `${i.firstName} ${i.lastName}`;
          return i;
        });
      },
      (err) => {}
    );
  }

  addUser() {
    this._addUserService.addUserModal(null).then(
      (result) => {
        this.reloadUsers();
      },
      (err) => {
        this.reloadUsers();
      }
    );
  }

  rowDoubleClick(row) {
    this._addUserService.addUserModal(row.data.id).then(
      (result) => {
        this.reloadUsers();
      },
      (err) => {
        this.reloadUsers();
      }
    );
  }

  public async showAccountModal(rowBtnClick) {
    if (rowBtnClick.button === "view") {
      this._addUserService.addUserModal(rowBtnClick.rowData.id).then(
        (result) => {
          this.reloadUsers();
        },
        (err) => {
          this.reloadUsers();
        }
      );
    } else if (rowBtnClick.button === "lock") {
      if (
        rowBtnClick.rowData.accountLocked === "0" ||
        rowBtnClick.rowData.accountLocked === 0
      ) {
        const result = await this._modalConfirmationService.confirm(
          `${rowBtnClick.rowData.name}`,
          `Are you sure you want to lock this account?`
        );
        if (result === "confirm") {
          this._userService.lockUser(rowBtnClick.rowData.id).subscribe(
            (data) => {
              this.toastService.showToast(
                "success",
                "User locked",
                `${rowBtnClick.rowData.firstName} ${rowBtnClick.rowData.lastName} was locked successfully!`
              );
              this.reloadUsers();
            },
            (err) => {
              this.toastService.showToast(
                "error",
                "Locking failed",
                `Error occurred locking ${rowBtnClick.rowData.firstName} ${rowBtnClick.rowData.lastName}!`              );
              this.reloadUsers();
            }
          );
        }
      } else {
        // account already locked
        this.toastService.showToast(
          "warning",
          "Cannot lock",
          `Account already locked`
        );
      }
    } else if (rowBtnClick.button === "unlock") {
      if (
        rowBtnClick.rowData.accountLocked === "1" ||
        rowBtnClick.rowData.accountLocked === 1
      ) {
        const result = await this._modalConfirmationService.confirm(
          `${rowBtnClick.rowData.name}`,
          `Are you sure you want to unlock this account?`
        );
        if (result === "confirm") {
          this._userService.unlockUser(rowBtnClick.rowData.id).subscribe(
            (data) => {
              this.toastService.showToast(
                "success",
                "User unlocked",
                `${rowBtnClick.rowData.firstName} ${rowBtnClick.rowData.lastName} was unlocked successfully!`
              );
              this.reloadUsers();
            },
            (err) => {
              this.toastService.showToast(
                "error",
                "Unlocking failed",
                `Error occurred unlocking ${rowBtnClick.rowData.firstName} ${rowBtnClick.rowData.lastName}!`
              );
              this.reloadUsers();
            }
          );
        }
      } else {
        // account already unlocked
        this.toastService.showToast(
          "warning",
          "Cannot unlock",
          `Account already open`
        );
      }
    } else if (rowBtnClick.button === "re-invite") {
      const result = await this._modalConfirmationService.confirm(
        `${rowBtnClick.rowData.name}`,
        `Are you sure you want to re-invite this user?`
      );
      if (result === "confirm") {
        this._userService.reInviteUser(rowBtnClick.rowData.id).subscribe(
          (data) => {
            this.toastService.showToast(
              "success",
              "User Invited",
              `${rowBtnClick.rowData.firstName} ${rowBtnClick.rowData.lastName} was send a new invitation!`
            );
            this.reloadUsers();
          },
          (err) => {
            this.toastService.showToast(
              "error",
              "Invitation failed",
              `Error occurred re-inviting ${rowBtnClick.rowData.firstName} ${rowBtnClick.rowData.lastName}!`
            );
            this.reloadUsers();
          }
        );
      }
    }
  }
}
